/** Canonical color per listing status. Single source of truth — do not
 * redefine these hex values locally; import this map instead. */
export const LISTING_STATUS_COLOR: Record<string, string> = {
  Touring: '#8B8680',
  'Due Diligence': '#DB5282',
  'Offer Submitted': '#FF9A4D',
  'Under Contract': '#FFF981',
  Pending: '#5AE9FF',
  /** Read compatibility for records created before Escrow was renamed Pending. */
  Escrow: '#5AE9FF',
  Closed: '#C0FF02',
  Lost: '#B4A7D6',
  Passed: '#bbb7af',
};
